module.exports = "<div class=\"compose-attachment-info\">\r\n\t<i class=\"upload-status iconfont\" ng-class=\"attachmentStatus()\"></i>\r\n\t<i class=\"iconfont icon-iconaccessory\"></i>\r\n\t<span class=\"attachment-count\">{{attachmentNo()}}</span>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/attachment.html
// module id = gTlZ
// module chunks = 1